import { createContext, FunctionComponent, useContext, useMemo } from "react";
import type { IProps, ISteppedFlowStepScope } from "./stepped-flow-step-scope.types";

/**
 * Defaults to active so a step rendered outside a SteppedModal.Formik or SteppedDrawer.Formik (e.g. in
 * isolation in a test or story) still shows its children, and registration is a no-op.
 */
const SteppedFlowStepScopeContext = createContext<ISteppedFlowStepScope>({
    isActive: true,
    index: 0,
    registerValidation: () => {},
});

/**
 * Tells one step which index it occupies, whether it is the active step, and how to register its
 * validation with the owning shell. The shell renders one of these per step.
 */
export const SteppedFlowStepScope: FunctionComponent<IProps> = ({ index, isActive, registerValidation, children }) => {
    const value = useMemo(() => ({ index, isActive, registerValidation }), [index, isActive, registerValidation]);
    return <SteppedFlowStepScopeContext.Provider value={value}>{children}</SteppedFlowStepScopeContext.Provider>;
};

export const useStepScope = (): ISteppedFlowStepScope => useContext(SteppedFlowStepScopeContext);
